const installationInstructions = {
  intro: {
    currentStep: 'intro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: true,
    includePairingProcess: true,
    isLastPage: false,
    nextStep: 'installController',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a Niro garage door controller!',
    haloDeviceResource: require('@/assets/device-models/MOGA-001/Niro_halo.png'),
    resource: require('@/assets/device-models/MOGA-001/hik-niro-cam.png'),
    resourceType: 'image',
    secondaryText: 'To get your device up and running we\'ll guide you through the ',
    continueButtonText: 'Start installation',
    alternateNextStep: {
      nextStep: 'letsGetStarted',
      nextStepName: 'instructions',
      title: 'Skip to pairing',
    },
  },
  installController: {
    currentStep: 'installController',
    headerIcon: 'arrowGrey',
    prevStepName: 'installationIntro',
    isLastPage: false,
    primaryText: 'Installation instructions',
    secondaryText: 'Follow the instructions in the set up guide included with Niro to connect it to your garage door opener.',
    steps: [
      {
        title: 'Attach wires to garage opener',
        description: 'Unplug your garage door opener and connect the provided wires into the same wire terminal on your garage door opener as your wall remote console.',
        stepNumber: 1
      },
      {
        title: 'Attach the wires to Niro',
        description: 'Connect the other end of the provided wires to top of the two terminals on the back of your Niro and plug your garage door opener back in.',
        stepNumber: 2,
        image: require('@/assets/device-models/MOGA-001/Niro_back_install.png'),
      },
    ],
    nextStep: 'powerOnCamera',
    nextStepName: 'instructions',
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'installController', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
  },
  powerOnCamera: {
    currentStep: 'powerOnCamera',
    headerIcon: 'arrowGrey',
    prevStep: 'installController',
    prevStepName: 'instructions',
    isLastPage: false,
    resourceType: 'image',
    resource: require('@/assets/device-models/MOGA-001/Niro_Plug.png'),
    primaryText: 'Power on your device',
    secondaryText: 'After you have installed your Niro, plug it in using the supplied power adapter. The light on the front of your device will turn on when the device is on.',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStep: 'powerOnCamera',
    prevStepName: 'instructions',
    resourceType: 'video',
    resource: require('@/assets/device-models/MOGA-001/Garage-Door_Pairing-Mode_Animation.mp4'),
    poster: require('@/assets/device-models/MOGA-001/Garage-Door_Pairing-Mode_Animation_poster.png'),
    videoType: 'video/mp4',
    videoAutoPlay: 'autoplay',
    videoLoop: 'loop',
    videoControls: false,
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the device before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Voice confirmation',
        description: 'You will hear a voice confirmation from the device when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a double blinking blue.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/MOGA-001/Niro_Reset_button.png'),
    primaryText: 'Putting Niro into Pairing Mode',
    secondaryText: 'If the light on the front of the device is not double blinking blue, it is not in pairing mode. To manually put the Niro into pairing mode:',
    steps: [
      {
        title: 'Press and hold',
        description: 'Press and hold the button on the back of your device.',
        stepNumber: 1
      },
      {
        title: 'Release',
        description: 'Release the button as soon as you see the light on the front of the device turn solid red.',
        stepNumber: 2
      },
      {
        title: 'Voice confirmation',
        description: 'After Niro finishes restarting, you will hear a voice confirmation indicating the device is ready to pair. The light on the front of the device will turn to double blinking blue.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  garageDoor: {
    currentStep: 'garageDoor',
    headerIcon: 'closeBlack',
    primaryText: 'To add another door, first connect Niro to your garage door opener',
    secondaryText: 'Follow the instructions in the set up guide included with the Niro to connect to your garage door opener',
    steps: [
      {
        title: 'Attach wires to garage opener',
        description: 'Unplug your garage door opener and connect the provided wires into the same wire terminal on your garage door opener as your wall remote console.',
        stepNumber: 1
      },
      {
        title: 'Attach the wires to Niro',
        description: 'Connect the other end of the provided wires to the top of the two terminals on the back of your Niro and plug your garage door opener back in.',
        image: require('@/assets/device-models/MOGA-001/Niro_back_install.png'),
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'garageDoor', // go back to this step when home advisor is closed
      title: 'Get installation help',
    },
    primaryActionKey: 'addDoor',
    continueButtonText: 'Add door',
    isLastPage: true,
    lastPageExitUrl: 'https://return-to-app',
  },
};

export default installationInstructions;
